import React from 'react'
import { useWorkListViewMnStore } from 'context/WorkListViewStore/Manager/WorkListViewStore.manager'
import ReactAudioPlayer from 'components/AudioPlayer'
import StandardTable from 'asterX-UI/Table/StandardTable'
import moment from 'moment/moment'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import { PhoneIncomeIcon, PhoneOutgoingIcon } from 'asterX-UI/Icons'
import FieldInfo from 'asterX-UI/DataDisplay/FieldInfo'
import { Link } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

const CallsTab = () => {
  const { workListViewStore } = useWorkListViewMnStore()
  const data = workListViewStore?.calls
  /*
{
  abonentName: '9924'
  callID: 'b508983a-69fa-4b6b-869f-85c5613da94d'
  conversationDuration: 0
  createdDate: '2023-10-22T10:00:05.691+0000'
  direction: 'outbound'
  groupNumber: null
  id: 846667
  phone: '79631111212'
  ringDate: '2023-10-22 15:31:04'
  ringDuration: '00:00'
  status: 'Вызов отменен'
  subscriberId: 731,
  callLink: null
}
   * */
  const columns = [
    'Дата/время',
    'Запись',
    'Номер телефона',
    'Длительность',
    'Тип звонка',
    'Статус'
  ]

  const rows = data?.map((call, index) => {
    const {
      createdDate,
      calldate,
      callLink,
      link,
      duration,
      groupNumber,
      phoneNumber,
      ringDuration,
      ringDate,
      direction,
      abonentName,
      status
    } = call
    const date = ringDate
      ? moment(new Date(ringDate)).format('DD MMM YYYY HH:mm')
      : createdDate
      ? moment(new Date(createdDate)).format('DD MMM YYYY HH:mm')
      : moment(new Date(calldate)).format('DD MMM YYYY HH:mm') || '-'
    const phone = groupNumber
      ? groupNumber?.toString()?.toPhone()
      : abonentName
      ? abonentName
      : phoneNumber || '-'
    return [
      date,
      callLink ? (
        <ReactAudioPlayer src={callLink} controls />
      ) : link ? (
        <FieldInfo
          value={
            <Link
              color={`${GRAY_COLORS[600]}`}
              onClick={() => window.open(link, '_blank')}
            >
              Прослушать звонок
            </Link>
          }
        />
      ) : (
        'Нет записи'
      ),
      phone,
      ringDuration || `${duration} сек`,
      ['income', 'in'].includes(direction) ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5
          }}
        >
          <PhoneIncomeIcon /> Входяший
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5
          }}
        >
          <PhoneOutgoingIcon /> Исходящий
        </div>
      ),
      <ChipStandard>{status}</ChipStandard>
    ]
  })
  return (
    <div
      style={{
        width: '99%'
      }}
    >
      <StandardTable
        tableData={{
          names: columns,
          rows: rows
        }}
      />
    </div>
  )
}
export default CallsTab
